import React from 'react'
import { useContext,useEffect } from 'react'
import noteContext from '../../contex/notes/noteContext'
import NoteFile from './NoteFile'
import Login from '../Authentication/Login'

const Notes = () => {

  const authtoken = localStorage.getItem("token")
  let user= false
   if(authtoken){
    user = true
   }
  
   const context = useContext(noteContext)
   const {file,fetchfileinfo} = context
   useEffect(() => {
    fetchfileinfo()
      // eslint-disable-next-line
    }, [])
   
   if(user){
    
  return (
    <>
    <div className=" d-flex flex-wrap " style={{padding: "62px 49px 0px",background: "url(https://cdn.pixabay.com/photo/2016/11/23/01/27/night-1851685_1280.png)",backgroundRepeat : "no-repeat" , backgroundSize :"cover",height:window.screen.height}}>
    {file.map((e)=>{
       return(<NoteFile key = {e._id} fileinfo = {e}/>)
    })}
    </div>
    <div className="addfile">
      <button type="button" className="btn add btn-dark" data-bs-toggle="modal" data-bs-target="#exampleModal">
        New file
      </button>

      <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ backdropFilter: "blur(2px)"}}>
        <div className="modal-dialog">
          <div className="modal-content" style={{fontFamily: "monospace",  background: "#b1b1b1"}}>
            <div className="modal-header"  style={{ borderBottom:" .5px solid #9b9999"}}>
              <h1 className="modal-title fs-5" id="exampleModalLabel">Add new file</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <form method="post" action= {`https://imanager-api-z2gy.onrender.com/api/file/addfile/${authtoken}`}  id="formFile"  encType="multipart/form-data">   
                <div>
                    <input className="btn" type="file" name="file" id="file" style={{border:" 0px"}}/>
                </div>      
                <button className="my-2 btn btn-info"  type="submit" value="submit">Upload</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}else{
  return(
    <>
      <Login/>
    </>
  )
}

}

export default Notes
